import i18n from '@/i18n'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

function firstRowLabel (vm) {
  let myRow = []
  const label = [
    { text: vm.$t('report_monthly.cash_in_hand'), style: 'th', alignment: 'center' },
    { text: vm.$t('report_monthly.bank_deposit'), style: 'th', alignment: 'center' },
    { text: vm.$t('report_monthly.total_cash_surplus_one'), style: 'th', alignment: 'center' },
    {},
    {},
    {}
  ]
  vm.subServiceTypeList.forEach(el => {
    label.push({ text: i18n.locale === 'bn' ? el.text_bn : el.text_en, style: 'th', alignment: 'center' })
  })
  const moreLabel = [
    { text: vm.$t('report_monthly.total_cash_expenditure'), style: 'th', alignment: 'center' },
    { text: vm.$t('report_monthly.cash_in_hand'), style: 'th', alignment: 'center' },
    { text: vm.$t('report_monthly.bank_deposit'), style: 'th', alignment: 'center' },
    { text: vm.$t('report_monthly.total_cash_surplus_two'), style: 'th', alignment: 'center' }
  ]
  myRow = [...label, ...moreLabel]
  return myRow
}

function secondRowLabel (vm) {
  const label = []
  vm.subServiceTypeList.forEach(el => {
    label.push({ text: i18n.locale === 'bn' ? el.text_bn : el.text_en, rowSpan: 2, style: 'th', alignment: 'center' })
  })
  label.push(
    { text: vm.$t('report_monthly.sum_of_total_beneficiary_patient'), rowSpan: 2, style: 'th', alignment: 'center' },
    { text: vm.$t('report_monthly.women'), style: 'th', rowSpan: 2, alignment: 'center' },
    { text: vm.$t('report_monthly.man'), style: 'th', rowSpan: 2, alignment: 'center' },
    { text: vm.$t('report.baby'), style: 'th', colSpan: 3, alignment: 'center' },
    {},
    {},
    {},
    {},
    {},
    {}
  )
  return label
}

function firstRowData (vm, reportData) {
  const label = [
    { text: vm.$n(reportData.till_p_month_deposit.cash_in_hand), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.till_p_month_deposit.bank_deposit), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.till_p_month_deposit.total_cash_deposit), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.reported_month_deposit), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.reported_month_total_deposit), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.reported_month_withdraw), style: 'td', alignment: 'center' }
  ]
  vm.subServiceTypeList.forEach(el => {
    label.push({ text: vm.$n(vm.getExpenseAmount(el.value)), style: 'td', alignment: 'center' })
  })
  label.push(
    { text: vm.$n(vm.getTotalExpense()), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.till_c_month_deposit.cash_in_hand), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.till_c_month_deposit.bank_deposit), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.till_c_month_deposit.total_cash_deposit), style: 'td', alignment: 'center' }
  )
  return label
}

function secondRowData (vm, reportData) {
  const label = []
  vm.subServiceTypeList.forEach(el => {
    label.push({ text: vm.$n(vm.getPatientNumber(el.value)), style: 'td', alignment: 'center' })
  })

  label.push(
    { text: vm.$n(reportData.assistance_patient.length, { useGrouping: false }), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.gender_wise_patient.total_female), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.gender_wise_patient.total_male), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.gender_wise_patient.total_boy), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.gender_wise_patient.total_girl), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.gender_wise_patient.total_girl + reportData.gender_wise_patient.total_boy), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.total_deposit), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.total_expense), style: 'td', alignment: 'center' },
    { text: vm.$n(reportData.total_patient), style: 'td', alignment: 'center' },
    {}
  )
  return label
}

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
  try {
    // Translation
    if (i18n.locale === 'bn') {
      pdfMake.vfs = pdfFontsBn.pdfMake.vfs
    } else {
        pdfMake.vfs = pdfFontsEn.pdfMake.vfs
    }

    // API Call
    const reportHeading = await ReportHeading.getReportHead(baseUrl, uri, orgId)

    const pdfContent = []

    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['25%', '50%', '25%'],
          body: [
            [
              { image: reportHeading.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
              { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
              { image: reportHeading.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
            ],
            [
              {},
              { text: vm.$t('social_service.dss'), style: 'header2', alignment: 'center' },
              {}
            ],
            [
              {},
              {},
              {}
            ],
            [
              {},
              { text: reportHeading.address, style: 'address', alignment: 'center' },
              {}
            ],
            [
              {},
              { text: reportTitle, style: 'address2', alignment: 'center' },
              {}
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      }
    )
    pdfContent.push(
      { text: '', style: 'empty_space' }
    )
    // searching field
    pdfContent.push(
      {
        table: {
          style: 'tableData',
          headerRows: 0,
          widths: ['50%', '30%', '20%'],
          body: [
            [
              { },
              { },
              { }
            ],
            [
              { text: vm.$t('report_monthly.workplace_name') + ': ' + vm.getHospitalName(parseInt(titleData.hospital_id)), style: 'td2', alignment: 'left' },
              { text: vm.$t('globalTrans.fiscalYear') + ': ' + vm.getFiscalYearName(parseInt(titleData.fiscal_year_id)), style: 'td2', alignment: 'left' },
              { text: vm.$t('globalTrans.month') + ': ' + vm.getMonthName(parseInt(titleData.month_id)), style: 'td2', alignment: 'right' }
            ],
            [
              { text: vm.$t('globalTrans.division') + ': ' + (parseInt(titleData.division_id) ? vm.getDivisionName(parseInt(titleData.division_id)) : vm.$t('globalTrans.all')), style: 'td2', alignment: 'left' },
              { text: vm.$t('globalTrans.district') + ': ' + (parseInt(titleData.district_id) ? vm.getDistrictName(parseInt(titleData.district_id)) : vm.$t('globalTrans.all')), style: 'td2', alignment: 'left' },
              {}
            ]
          ]
        },
        layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
      }
    )

    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['4%', '5%', '6%', '6%', '6%', '6%', '5.5%', '6%', '5%', '3.5%', '8%', '4%', '7%', '5%', '8%', '4%', '5%', '6%'],
          body: [
            [
              { text: vm.$t('report_monthly.previous_month_benefited_amount'), colSpan: 3, style: 'th', alignment: 'center' },
              {},
              {},
              { text: vm.$t('report_monthly.allotment_amount_received'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.sum_of_total_deposit'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.withdrawal_from_bank'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.reporting_month_expense'), colSpan: 9, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.amount_of_end_month'), colSpan: 3, style: 'th', alignment: 'center' },
              {},
              {}
            ],
            firstRowLabel(vm),
            [
              { text: vm.$n(1), style: 'th', alignment: 'center' },
              { text: vm.$n(2), style: 'th', alignment: 'center' },
              { text: vm.$n(3), style: 'th', alignment: 'center' },
              { text: vm.$n(4), style: 'th', alignment: 'center' },
              { text: vm.$n(5), style: 'th', alignment: 'center' },
              { text: vm.$n(6), style: 'th', alignment: 'center' },
              { text: vm.$n(7), style: 'th', alignment: 'center' },
              { text: vm.$n(8), style: 'th', alignment: 'center' },
              { text: vm.$n(9), style: 'th', alignment: 'center' },
              { text: vm.$n(10), style: 'th', alignment: 'center' },
              { text: vm.$n(11), style: 'th', alignment: 'center' },
              { text: vm.$n(12), style: 'th', alignment: 'center' },
              { text: vm.$n(13), style: 'th', alignment: 'center' },
              { text: vm.$n(14), style: 'th', alignment: 'center' },
              { text: vm.$n(15), style: 'th', alignment: 'center' },
              { text: vm.$n(16), style: 'th', alignment: 'center' },
              { text: vm.$n(17), style: 'th', alignment: 'center' },
              { text: vm.$n(18), style: 'th', alignment: 'center' }
            ],
            firstRowData(vm, data)
          ]
        }
      }
    )

    pdfContent.push(
      { text: '', style: 'empty_space' }
    )

    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['6%', '6%', '5%', '3%', '8%', '4%', '7%', '8%', '8%', '3%', '3.5%', '4%', '4.5%', '3.5%', '7%', '7%', '7%', '5.5%'],
          body: [
            [
              { text: vm.$t('report_monthly.no_of_benefited_patient'), colSpan: 9, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.total_benefited_patient_gender'), colSpan: 5, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.total_income_from_start'), rowSpan: 3, style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.total_expense_from_start'), rowSpan: 3, style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.total_patient_from_start'), rowSpan: 3, style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.comment'), rowSpan: 3, style: 'th', alignment: 'center' }
            ],
            secondRowLabel(vm),
            [
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              { text: vm.$t('social_service.boy'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.girl'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.total_child'), style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {}
            ],
            [
              { text: vm.$n(19), style: 'th', alignment: 'center' },
              { text: vm.$n(20), style: 'th', alignment: 'center' },
              { text: vm.$n(21), style: 'th', alignment: 'center' },
              { text: vm.$n(22), style: 'th', alignment: 'center' },
              { text: vm.$n(23), style: 'th', alignment: 'center' },
              { text: vm.$n(24), style: 'th', alignment: 'center' },
              { text: vm.$n(25), style: 'th', alignment: 'center' },
              { text: vm.$n(26), style: 'th', alignment: 'center' },
              { text: vm.$n(27), style: 'th', alignment: 'center' },
              { text: vm.$n(28), style: 'th', alignment: 'center' },
              { text: vm.$n(29), style: 'th', alignment: 'center' },
              { text: vm.$n(30), style: 'th', alignment: 'center' },
              { text: vm.$n(31), style: 'th', alignment: 'center' },
              { text: vm.$n(32), style: 'th', alignment: 'center' },
              { text: vm.$n(33), style: 'th', alignment: 'center' },
              { text: vm.$n(34), style: 'th', alignment: 'center' },
              { text: vm.$n(35), style: 'th', alignment: 'center' },
              { text: vm.$n(36), style: 'th', alignment: 'center' }
            ],
            secondRowData(vm, data)
          ]
        }
      }
    )

    var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [30, 40, 30, 40],
      styles: {
          th: {
            fontSize: 7.5,
            margin: [2, 2, 2, 2],
            bold: true
          },
          td: {
            fontSize: 8,
            margin: [2, 2, 2, 2]
          },
          td2: {
              fontSize: 9,
              margin: [2, 1, 2, 1]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
      }
    }

    pdfMake.createPdf(docDefinition, null, null, null).print()
  } catch (error) {
    if (error) {
    }
  }
}

export default {
  exportPdfDetails
}
